import script from "./serialNo.vue?vue&type=script&setup=true&lang=js"
export * from "./serialNo.vue?vue&type=script&setup=true&lang=js"

import "./serialNo.vue?vue&type=style&index=0&id=32518c8c&scoped=true&lang=css"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32518c8c"]])

export default __exports__